import { render } from "./CommunityDetails.vue?vue&type=template&id=42bcc62b&scoped=true"
import script from "./CommunityDetails.vue?vue&type=script&lang=js"
export * from "./CommunityDetails.vue?vue&type=script&lang=js"

import "./CommunityDetails.vue?vue&type=style&index=0&id=42bcc62b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42bcc62b"]])

export default __exports__